import {atom} from "recoil";

const editingOperatorState = atom<string | undefined>({
    key: "editing-operator-context",
    default: undefined
});

export default editingOperatorState;
